<template>
<AspectEnforcer :format="format">
  <div class="book" :class="{frontcover: currentPage==1, backcover: currentPage==visibleData.length-1}">
    <template v-for="(page, index) in visibleData">
      <transition :name="turnStyle">
        <div
          v-if="index==currentPage-1 || index==currentPage"
          class="page is-unselectable clickable"
          :class="{'page-left': (index&1) == 0,
                  'page-right': (index&1) == 1,
                  'page-hard': page.paper=='hard',
                  'page-none': page.paper=='none'}"
          :key="index"
          @click="onClick(index)">
          <div class="page-contents">
            <slot v-if="$scopedSlots.default" :content="page.content" :index="index"/>
            <div v-else="$scopedSlots.default" v-html="page.content"></div>
            <div class="shadow-box"></div>
          </div>
        </div>
        <div v-else-if="index >= currentPage-3 && index<=currentPage+2">
          <div class="page-preloader">
            <slot v-if="$scopedSlots.default" :content="page.content" :index="index"/>
            <div v-else="$scopedSlots.default" v-html="page.content"></div>
          </div>
        </div>
    </transition>
  </template>
  </div>
</AspectEnforcer>
</template>

<script>
import AspectEnforcer from '@/components/AspectEnforcer'

// note: internally currentPage=pagenum+1 to allow for our sentinal
// _none_ pages
export default {
  name: 'FlipBook',
  components: {
    AspectEnforcer,
  },
  data: function() { return {
    currentPage: this.pagenum+1,
    turnStyle: 'turn-next',
  }},
  props: {
    pages: { type: Array, required: true },
    pagenum: { type: Number, default: 0 },
    format: { type: String, default: 'a4' },
  },
  computed: {
    visibleData: function() {
      var pages = this.pages;
      var pp = [{paper: 'none', content:''}]
      for (var i=0; i<pages.length; ++i) {
        var paper = (i<2 || i>=pages.length-2) ? 'hard' : 'soft'
        pp.push({paper: paper, content: pages[i]})
      }
      pp.push({paper: 'none', content:''})
      return pp
    },
    rightPageNum: function() {
      // in terms of provided pages, excluding sentinal
      return this.currentPage - 1
    },
  },
  watch: {
    pagenum: function(newVal) {
      var newPage = ((newVal+1) & ~1) + 1;
      newPage = Math.min(newPage, this.visibleData.length-1)
      newPage = Math.max(newPage, 1)
      if (newPage != this.currentPage) {
        this.turn(newPage - this.currentPage)
      }
    }
  },
  methods: {
    onClick: function(index) {
      if (index==this.currentPage-1 && this.currentPage > 1) {
        this.turn(-2)
      } else if (index==this.currentPage && this.currentPage < this.visibleData.length-2) {
        this.turn(2)
      }
    },
    turn: function(delta) {
      this.turnStyle = delta > 0 ? 'turn-next' : 'turn-prev';
      this.$nextTick(function() {
        this.currentPage += delta
        this.$emit('update:pagenum', this.currentPage-1)
      })
    }
  },
}
</script>

<style scoped>

.book {
    width: 100%;
    height: 100%;
  transition: transform 0.5s;
}
.book.frontcover {
    transform: translateX(-24%);
}
.book.backcover {
    transform: translateX(24%);
}

.page {
    width:50%;
    height:100%;
    vertical-align: top;
    display: none;
    position: absolute;
    top: 0;
    animation-duration: 0.5s;
    animation-timing: linear;
    background-color: white;
    border: 1px solid #ccc;
}
.page.clickable {
    cursor: grab;
}
.page-left {
    left: 0;
    display: block;
    transform-origin: top right;
}
.page-right {
    right: 0;
    display: block;
    transform-origin: top left;
}
.page-none {
    display: none !important;
}

@keyframes page-right-out {
    0% {transform: skewY(0) scaleX(1); opacity: 1;}
    50% {transform: skewY(-89deg) scaleX(0); opacity: 1;}
    100% {transform: skewY(-89deg) scaleX(0); opacity: 0;}
}
@keyframes page-left-in {
    0% {transform: skewY(89deg) scaleX(0); opacity: 0;}
    50% {transform: skewY(89deg) scaleX(0); opacity: 1;}
    100% {transform: skewY(0deg) scaleX(1); opacity: 1;}
}
@keyframes page-appear {
    0% { opacity: 1; }
    100% { opacity: 1; }
}
.page-right.turn-next-leave-active {
    animation-name: page-right-out;
    z-index: 20;
}
.page-right.turn-prev-enter-active {
    animation-name: page-right-out;
    animation-direction: reverse;
    z-index: 20;
}
.page-right.turn-next-enter-active {
    animation-name: page-appear;
}
.page-right.turn-prev-leave-active {
    animation-name: page-appear;
    animation-direction: reverse;
}
.page-left.turn-next-enter-active{
    animation-name: page-left-in;
    z-index: 20;
}
.page-left.turn-prev-leave-active {
    animation-name: page-left-in;
    animation-direction: reverse;
    z-index: 20;
}
.page-left.turn-prev-enter-active {
    animation-name: page-appear;
}
.page-left.turn-next-leave-active {
    animation-name: page-appear;
    animation-direction: reverse;
}

.page-hard{
    x-background:#ccc !important;
    font-weight:bold;
}
.page-contents {
    width: 100%;
    height: 100%;
    position: relative;
}
.page-left .page-contents {
    box-shadow: 0px 6px 10px #555;
}
.page-right .page-contents,
.backcover .page-left .page-contents {
    box-shadow: 6px 6px 10px #555;
}

.shadow-box {
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
}
.page-right .shadow-box {
    box-shadow: inset 10px 0 12px -10px rgba(0,0,0,0.6);
}    
.page-left .shadow-box {
    box-shadow: inset -10px 0 12px -10px rgba(0,0,0,0.6);
}
.page-preloader {
    width: 10vw;
    height: 1vh;
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/FlipBook.vue